<template>
  <div class="main-page">
    <div class="main-page__title">
      <h1 class="text-rothek">
        {{ $t('mainPage.learn') }} {{ $t('mainPage.fromRussia') }} <span class="color-blue">{{ $t('mainPage.forWorld') }}</span> <span class="color-red">{{ $t('mainPage.forYourself') }}</span>
        <br/><small><span class="color-orange">{{ $t('mainPage.universe') }}</span></small>
      </h1>
      <router-link to="/catalog" class="btn btn-lg mt-40">{{ $t('buttons.startLearning') }}</router-link>
      <div class="main-page__links-md">
        <a target="_blank" href="https://universarium-school.ru" class="fill bg-orange p-20 mt-80">
          <div class="d-flex justify-space-between">
            <div>
              <div class="main-page__links-md__title">{{ $t('mainPage.universarium') }}</div>
            </div>
            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.3388 2.00007C22.3388 0.895496 21.4434 6.51821e-05 20.3388 6.51821e-05H2.3388C1.23423 6.51821e-05 0.338802 0.895496 0.338802 2.00007C0.338802 3.10463 1.23423 4.00007 2.3388 4.00007H18.3388V20.0001C18.3388 21.1046 19.2342 22.0001 20.3388 22.0001C21.4434 22.0001 22.3388 21.1046 22.3388 20.0001V2.00007ZM4.07535 21.0919L21.753 3.41428L18.9246 0.585852L1.24692 18.2635L4.07535 21.0919Z" fill="#1F1F1F"/>
            </svg>
          </div>
        </a>
        <a target="_blank" href="https://edu-oko.ru/?id=254" class="fill bg-green p-20 mt-16">
          <div class="d-flex justify-space-between">
            <div>
              <div class="main-page__links-md__title">{{ $t('mainPage.universarium') }}</div>
            </div>
            <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.3388 2.00007C22.3388 0.895496 21.4434 6.51821e-05 20.3388 6.51821e-05H2.3388C1.23423 6.51821e-05 0.338802 0.895496 0.338802 2.00007C0.338802 3.10463 1.23423 4.00007 2.3388 4.00007H18.3388V20.0001C18.3388 21.1046 19.2342 22.0001 20.3388 22.0001C21.4434 22.0001 22.3388 21.1046 22.3388 20.0001V2.00007ZM4.07535 21.0919L21.753 3.41428L18.9246 0.585852L1.24692 18.2635L4.07535 21.0919Z" fill="#1F1F1F"/>
            </svg>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainPageTitle"
}
</script>

<style scoped>

</style>